import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";

const MemoFix = () => {
  
  const devMode = process.env.NODE_ENV === 'development';
  
  const { memoId } = useParams();
  const [slideoutFlag, setSlideoutFlag] = useState(false);
  const [memoTitle, _setMemoTitle] = useState('');
  const [memoContent, _setMemoContent] = useState('');
  const [memoColor, setMemoColor] = useState(0);
  const [memoCategory, setMemoCategory] = useState(0);
  const [categories, setCategories] = useState(null);
  const [headeruntop, setHeaderuntop] = useState(false);

  const setMemoTitle = e => {_setMemoTitle(e.target.value)};
  const setMemoContent = e => {_setMemoContent(e.target.value)};

  const navigate = useNavigate();

  const getCategories = () => {
    if (devMode) {
      fetch(`http://${window.location.hostname}:8080/mempad/cat/lst`).then(r=>r.json()).then(data=>{
        setCategories(data);
      });
    } else {
      fetch('/mempad/cat/lst').then(r=>r.json()).then(data=>{
        setCategories(data);
      });  
    }
  }

  const getMemoData = () => {
    if (devMode) {
      fetch(`http://${window.location.hostname}:8080/mempad/mem/get`, {method: 'post', body: JSON.stringify({id: memoId})}).then(r=>r.json()).then(data=>{
        _setMemoTitle(data.title);
        _setMemoContent(data.content);
        setMemoColor(data.color);
        setMemoCategory(data.category);
      });
    } else {
      const fd = new FormData();
      fd.append('id', memoId);
      fetch('/mempad/mem/get', {method: 'post', body: fd}).then(r=>r.json()).then(data=>{
        _setMemoTitle(data.title);
        _setMemoContent(data.content);
        setMemoColor(data.color);
        setMemoCategory(data.category);
      });
    }
  };

  useEffect(() => {
    getCategories();
    getMemoData();
  }, []);

  const backFunc = () => {
    setSlideoutFlag(true);
    setTimeout(() => navigate(-1), 250);
  }

  const changeHeaderStyle = e => {
    if (e.target.scrollTop <= 0 && headeruntop) setHeaderuntop(false);
    else if (e.target.scrollTop > 0 && !headeruntop) setHeaderuntop(true);
  }

  const fixMemo = () => {
    if (memoTitle.length > 0 && memoContent.length > 0) {
      if (devMode) {
        fetch(`http://${window.location.hostname}:8080/mempad/mem/fix`, {method: 'post', body: JSON.stringify({id: memoId, title: memoTitle, content: memoContent, category: memoCategory, color: memoColor})}).then(() => {
          backFunc();
        });
      } else {
        const fd = new FormData();
        fd.append('id', memoId);
        fd.append('title', memoTitle);
        fd.append('content', memoContent);
        fd.append('category', memoCategory);
        fd.append('color', memoColor);
        fetch('/mempad/mem/fix', {method: 'post', body: fd}).then(() => {
          backFunc();
        });
      }
    }
  }

  const delMemo = () => {
    if (window.confirm('本当にこのメモを削除しますか？')) {
      if (devMode) {
        fetch(`http://${window.location.hostname}:8080/mempad/mem/del`, {method: 'post', body: JSON.stringify({id: memoId})}).then(() => {
          backFunc();
        });
      } else {
        const fd = new FormData();
        fd.append('id', memoId);
        fetch('/mempad/mem/del', {method: 'post', body: fd}).then(() => {
          backFunc();
        });
      }
    }
  }

  return (
    <div id="memo-layout" className={slideoutFlag ? "layout layout-over-slideout" : "layout layout-over"}>
      <header className={headeruntop ? 'header-untop' : ''}>
        <a className="header-left" onClick={backFunc}>＜戻る</a>
        <h3 className="header-title">メモの追加</h3>
        <a className={memoTitle.length === 0 || memoContent.length === 0 ? 'header-right unactivelink' : 'header-right'} onClick={fixMemo}>編集</a>
      </header>
      <div className="top-scroller" onClick={e => e.target.parentElement.getElementsByTagName('main')[0].scrollTo({top:0, left:0, behavior: 'smooth'})} />
      <main onScroll={changeHeaderStyle}>
        <div className="content-box">
          <input className="line-input" type="text" value={memoTitle} onChange={setMemoTitle} placeholder="メモタイトル" />
          <hr />
          <textarea placeholder="メモ本文" rows={10} value={memoContent} onChange={setMemoContent}></textarea>
          <hr />
          {[...Array(13)].map((_, key) => 
            <span key={key}>
              <input hidden id={`colordata-${key}`} type="radio" name="colordata" value={key} checked={key === memoColor} onChange={() => setMemoColor(key)}/>
              <label className={`category-color bg-col${key}`} htmlFor={`colordata-${key}`} />
            </span>
          )}
          <hr />
          <select value={memoCategory} onChange={e => setMemoCategory(Number(e.target.value))}>
            {categories && categories.map((category, key) => 
              <option key={key} value={category.id}>{category.name}</option>
            )}
          </select>
        </div>
        <a className="listbox alertbox" onClick={delMemo}>メモを削除</a>
      </main>
    </div>
  );
}

export default MemoFix;